export const DATE_TIME_FORMAT = "dd/MM/yyyy HH:mm:ss";
export const DATE_FORMAT = "dd/MM/yyyy";
export const DEVICES_DATE_TIME_FORMAT = "MM/dd/yyyy HH:mm";
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_FORMAT_NO_SEC = 'HH:mm';
